import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserGuideComponent } from './user-guide/user-guide.component';
import { USERGUIDE_STATES } from './user-guide.states';
import { UIRouterModule } from '@uirouter/angular';

@NgModule({
  declarations: [
    UserGuideComponent
  ],
  imports: [
    CommonModule,
    UIRouterModule.forChild({ states: USERGUIDE_STATES }),
  ]
})
export class UserGuideModule { }
